import axiosNewApi from "../config/axiosNewApi";
import axios from "axios";
const sanitizeSearchTerm = (term) => {
  return term.trim().replace(/\s+/g, " ");
};

export const filters = async (searchTerm, signal) => {
  const sanitizedSearchTerm = sanitizeSearchTerm(searchTerm);
  return axiosNewApi.get(`mobile/filters/${sanitizedSearchTerm}`, {
    withCredentials: true,
    signal,
  });
};

export const guestFilters = async (searchTerm, signal) => {
  const sanitizedSearchTerm = sanitizeSearchTerm(searchTerm);
  return axiosNewApi.get(`mobile/filters/guest/${sanitizedSearchTerm}`, { signal });
};

export const getFiltersPrices = async (skus) => {
  try {
    const { data, status } = await axiosNewApi.post(
      `mobile/filters/prices`,
      { skus },
      { withCredentials: true }
    );

    if (status === 200) {
      return data.data;
    } else {
      throw new Error("Prices not found");
    }
  } catch (error) {
    console.error("Error fetching prices:", error);
    throw error;
  }
};
